import { useState, useEffect } from "react";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

export function getDefaultSettings() {
  return {
    programYear: "2025",
    submissionDeadline: "2025-07-06",
    submissionDeadlineTime: "11:59 PM",
    rsvpDeadline: "Thursday, August 4",
    groups: [
      { value: "16", label: "Group 16", description: "Seeking Full Time Employment", presents: false, slotMinutes: 30, minInterviews: 0 },
      { value: "17", label: "Group 17", description: "Seeking Spring & Summer Internships", presents: false, presentationType: "internship", slotMinutes: 30, minInterviews: 6 },
      { value: "18", label: "Group 18", description: "Seeking Spring or Summer Internship", presents: true, presentationType: "investment_or_internship", slotMinutes: 20, minInterviews: 5 },
    ],
    presentationStartTime: "08:00",
    presentationEndTime: "12:30",
    presentationBreakStart: "10:00",
    presentationBreakEnd: "10:30",
    maxPresentationRooms: 4,
    presentationTopics: ["Natural Gas", "Crude Oil", "Power", "Renewables", "Petrochemicals", "Other"],
    studentFerpaURL: "",
    boardFerpaURL: "",
    // Fully admin-configurable week: any number of days, each with its own
    // events. Only `type: "interviews"` events feed the scheduler; everything
    // else (draft/showcase/networking/breakfast/lunch/dinner/custom) is
    // informational display, and any event overlapping an "interviews" event
    // on the same day is carved out of that day's generated slots.
    boardWeek: {
      slotMinutes: 30,
      days: [
        { id: "d1", label: "Monday, August 18", events: [
          { id: "d1e1", type: "breakfast",  name: "Breakfast",          startTime: "7:30 AM", endTime: "8:30 AM", enabled: true },
          { id: "d1e2", type: "interviews", tier: "platinum", name: "Intern Interviews", startTime: "8:30 AM", endTime: "5:00 PM", enabled: true },
          { id: "d1e3", type: "lunch",      name: "Lunch",              startTime: "12:00 PM", endTime: "1:00 PM", enabled: true },
          { id: "d1e4", type: "networking", name: "Networking Dinner",  startTime: "6:00 PM", endTime: "9:00 PM", enabled: true },
        ]},
        { id: "d2", label: "Tuesday, August 19", events: [
          { id: "d2e1", type: "breakfast",  name: "Breakfast",          startTime: "7:30 AM", endTime: "8:30 AM", enabled: true },
          { id: "d2e2", type: "interviews", tier: "platinum", name: "Intern Interviews", startTime: "8:30 AM", endTime: "5:00 PM", enabled: true },
          { id: "d2e3", type: "lunch",      name: "Lunch",              startTime: "12:00 PM", endTime: "1:00 PM", enabled: true },
          { id: "d2e4", type: "draft",      tier: "platinum", name: "Platinum Draft", startTime: "5:00 PM", endTime: "", enabled: true },
        ]},
        { id: "d3", label: "Wednesday, August 20", events: [
          { id: "d3e1", type: "showcase",   name: "Showcase",           startTime: "8:00 AM", endTime: "12:00 PM", enabled: true },
          { id: "d3e2", type: "interviews", tier: "goldsilver", name: "Intern Interviews (Gold + Silver)", startTime: "1:00 PM", endTime: "5:00 PM", enabled: true },
          { id: "d3e4", type: "networking", name: "Networking Dinner",  startTime: "6:00 PM", endTime: "9:00 PM", enabled: true },
        ]},
        { id: "d4", label: "Thursday, August 21", events: [
          { id: "d4e1", type: "breakfast",  name: "Breakfast",          startTime: "7:30 AM", endTime: "8:30 AM", enabled: true },
          { id: "d4e2", type: "interviews", tier: "goldsilver", name: "Intern Interviews (Gold + Silver)", startTime: "8:30 AM", endTime: "5:00 PM", enabled: true },
          { id: "d4e4", type: "lunch",      name: "Lunch",              startTime: "12:00 PM", endTime: "1:00 PM", enabled: true },
          { id: "d4e5", type: "draft",      tier: "gold",   name: "Gold Draft",   startTime: "5:00 PM", endTime: "", enabled: true },
          { id: "d4e6", type: "draft",      tier: "silver", name: "Silver Draft", startTime: "6:00 PM", endTime: "", enabled: true },
        ]},
      ],
    },
  };
}

export default function useSettings() {
  const [settings, setSettings] = useState(() => {
    try { return JSON.parse(localStorage.getItem("tripProgramSettings") || "null") || getDefaultSettings(); }
    catch { return getDefaultSettings(); }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, "metadata", "programSettings")).then(snap => {
      if (snap.exists()) {
        const s = snap.data();
        delete s.updatedAt;
        setSettings(s);
        localStorage.setItem("tripProgramSettings", JSON.stringify(s));
      }
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return { settings, loading };
}
